import React, { useEffect, useState } from 'react';
import logo from './assets/image/LOGO_FCN.png';
import { 
  Snackbar, Alert, FormControl, Select, MenuItem, Grid, Typography, 
  TablePagination, TextField, Button, Paper, Box, InputLabel,
  useMediaQuery, useTheme, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Container, Chip, Tooltip, Skeleton, Collapse,
  IconButton, Fade, Grow
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Search, Clear, ExpandMore, ExpandLess , RestartAlt , Close} from '@mui/icons-material';
import { apiService, handleApiError } from '../config/api';

const Verificar = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    const [departamento, setDepartamento] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [asociacion, setAsociacion] = useState('');
    const [cooperativa, setCooperativa] = useState('');
    const [estatusFiltro, setEstatusFiltro] = useState(''); 
    const [busquedaNombre, setBusquedaNombre] = useState('');
    const [busquedaDNI, setBusquedaDNI] = useState('');
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');
    
    const [municipios, setMunicipios] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [municipiosFiltrados, setMunicipiosFiltrados] = useState([]);
    const [representantes, setRepresentantes] = useState([]);
    const [representantesFiltrados, setRepresentantesFiltrados] = useState([]);
    const [asociaciones, setAsociaciones] = useState({});
    const [cooperativasList, setCooperativasList] = useState([]);
    const [cooperativasFiltradas, setCooperativasFiltradas] = useState([]);
    const [cooperativasMap, setCooperativasMap] = useState({});
    const [alertMessage, setAlertMessage] = useState('');
    const [openAlert, setOpenAlert] = useState(false);
    const [alertType, setAlertType] = useState('info');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [loading, setLoading] = useState(true);
    const [filtersExpanded, setFiltersExpanded] = useState(true);

    const formatDate = (date, formatType = 'display') => {
        if (!date || date === '') {
            return '';
        }
        
        let d;
        
        if (typeof date === 'string') {
            if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
                const [year, month, day] = date.split('-').map(num => parseInt(num, 10));
                d = new Date(year, month - 1, day);
            } else {
                d = new Date(date);
            }
        } else {
            d = new Date(date);
        }
        
        if (isNaN(d.getTime())) {
            return '';
        }
        
        if (formatType === 'filename') {
            return `${d.getFullYear()}${(d.getMonth() + 1).toString().padStart(2, '0')}${d.getDate().toString().padStart(2, '0')}`;
        }
        
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        
        return `${day}/${month}/${year}`;
    };

    const formatDNI = (value) => {
        const numbersOnly = value.replace(/[^\d]/g, '');
        if (numbersOnly.length <= 4) {
            return numbersOnly;
        } else if (numbersOnly.length <= 8) {
            return `${numbersOnly.slice(0, 4)}-${numbersOnly.slice(4)}`;
        } else {
            return `${numbersOnly.slice(0, 4)}-${numbersOnly.slice(4, 8)}-${numbersOnly.slice(8, 13)}`;
        }
    };

    const getRowStyle = (estatus, index) => {
        const baseColor = index % 2 === 0 ? '#fcfaf7' : '#ffffff';
        
        if (estatus === 'VENCIDA') {
            return {
                backgroundColor: index % 2 === 0 ? '#fff8f0' : '#ffebdd',
                borderLeft: '4px solid #ff9800',
                transition: 'all 0.2s ease-in-out',
            };
        }
        return {
            backgroundColor: baseColor,
            transition: 'all 0.2s ease-in-out',
        };
    };

    const renderEstatusIcon = (estatus, representante) => {
        const nombreCompleto = representante?.nombre_representante || 'Representante';
        
        if (estatus === 'VENCIDA') {
            return (
                <Tooltip 
                    title={`${nombreCompleto} REPRESENTANTE VENCIDO, ACTUALIZAR DATOS.`} 
                    arrow
                    placement="top"
                >
                    <WarningIcon 
                        sx={{
                            color: '#ff0000',
                            fontSize: '20px',
                            cursor: 'pointer',
                            '&:hover': {
                                color: '#f57c00',
                                transform: 'scale(1.2)',
                                transition: 'all 0.3s ease-in-out'
                            }
                        }}
                    />
                </Tooltip>
            );
        } else if (estatus === 'VIGENTE') {
            return (
                <Tooltip 
                    title={`${nombreCompleto} REPRESENTANTE VIGENTE`} 
                    arrow
                    placement="top"
                >
                    <CheckCircleIcon 
                        sx={{
                            color: '#4caf50',
                            fontSize: '20px',
                            cursor: 'pointer',
                            '&:hover': {
                                color: '#388e3c',
                                transform: 'scale(1.2)',
                                transition: 'all 0.3s ease-in-out'
                            }
                        }}
                    />
                </Tooltip>
            );
        }
        return null;
    };

    const renderEstatusIndicator = (estatus) => {
        if (estatus === 'VENCIDA') {
            return (
                <Chip
                    icon={<WarningIcon />}
                    label="VENCIDA"
                    size="small"
                    sx={{
                        backgroundColor: '#ffecb3',
                        color: '#e65100',
                        fontWeight: 'bold',
                        border: '1px solid #ff9800',
                        boxShadow: '0 2px 4px rgba(255, 152, 0, 0.2)',
                    }}
                />
            );
        } else if (estatus === 'VIGENTE') {
            return (
                <Chip
                    icon={<CheckCircleIcon />}
                    label="VIGENTE"
                    size="small"
                    sx={{
                        backgroundColor: '#e8f5e8',
                        color: '#2e7d32',
                        fontWeight: 'bold',
                        border: '1px solid #4caf50',
                        boxShadow: '0 2px 4px rgba(76, 175, 80, 0.2)',
                    }}
                />
            );
        }
        return null;
    };

    const SkeletonTable = () => (
        <Box>
            {[...Array(5)].map((_, index) => (
                <Box key={index} sx={{ display: 'flex', gap: 2, mb: 1, p: 1 }}>
                    <Skeleton variant="circular" width={40} height={40} />
                    <Skeleton variant="rectangular" width="20%" height={40} />
                    <Skeleton variant="rectangular" width="25%" height={40} />
                    <Skeleton variant="rectangular" width="15%" height={40} />
                    <Skeleton variant="rectangular" width="15%" height={40} />
                    <Skeleton variant="rectangular" width="20%" height={40} />
                    <Skeleton variant="rectangular" width="15%" height={40} />
                </Box>
            ))}
        </Box>
    );

    const SkeletonCards = () => (
        <Box>
            {[...Array(3)].map((_, index) => (
                <Paper key={index} elevation={1} sx={{ mb: 2, p: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Skeleton variant="rectangular" width="60%" height={24} />
                        <Skeleton variant="rectangular" width="30%" height={24} />
                    </Box>
                    <Grid container spacing={1}>
                        {[...Array(6)].map((_, i) => (
                            <React.Fragment key={i}>
                                <Grid item xs={5}>
                                    <Skeleton variant="text" width="80%" height={16} />
                                </Grid>
                                <Grid item xs={7}>
                                    <Skeleton variant="text" width="90%" height={16} />
                                </Grid>
                            </React.Fragment>
                        ))}
                    </Grid>
                </Paper>
            ))}
        </Box>
    );

    const handleBusquedaDNIChange = (e) => {
        const formattedDni = formatDNI(e.target.value);
        setBusquedaDNI(formattedDni);
        setTimeout(handleVerificarRepresentantes, 300);
    };
    
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const [
                    departamentosData,
                    municipiosData,
                    representantesData,
                    asociacionesData,
                    cooperativasData
                ] = await Promise.all([
                    apiService.geografia.getDepartamentos(),
                    apiService.geografia.getMunicipios(),
                    apiService.representantes.getAll(),
                    apiService.asociaciones.getAll(),
                    apiService.cooperativas.getAll()
                ]);
                
                setDepartamentos(departamentosData || []);
                setMunicipios(municipiosData || []);
                
                const representantesActivos = (representantesData || []).filter(
                    rep => (rep.estatus === "VIGENTE" || rep.estatus === "VENCIDA") &&
                    rep.categorias &&
                    rep.categorias.length > 0 &&
                    rep.categorias.some(categoria => categoria.Id === 3 && categoria.Estado !== 'Inactivo')
                );
                
                setRepresentantes(representantesActivos);
                
                const asociacionesMap = {};
                (asociacionesData || []).forEach(asoc => {
                    asociacionesMap[asoc.cod_asociacion] = asoc.nombre_abreviado;
                });
                setAsociaciones(asociacionesMap);
                
                setCooperativasList(cooperativasData || []);
                const coopMap = {};
                (cooperativasData || []).forEach(coop => {
                    coopMap[coop.cod_cooperativa] = coop.nombre_cooperativa;
                });
                setCooperativasMap(coopMap);
                
                setLoading(false);
                
            } catch (error) {
                const errorMessage = handleApiError(error, 'Error al cargar los datos. Por favor, intente nuevamente.');
                setAlertMessage(errorMessage);
                setAlertType('error');
                setOpenAlert(true);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (departamento) {
            const filteredMunicipios = municipios.filter(mun => 
                String(mun.CodigoDepartamento) === String(departamento)
            );
            setMunicipiosFiltrados(filteredMunicipios);
            setMunicipio('');
        } else {
            setMunicipiosFiltrados([]);
        }
    }, [departamento, municipios]);
    
    useEffect(() => {
        if (asociacion) {
            const filteredCooperativas = cooperativasList.filter(coop => 
                String(coop.cod_asociacion) === String(asociacion)
            );
            setCooperativasFiltradas(filteredCooperativas);
            setCooperativa(''); 
        } else {
            setCooperativasFiltradas([]);
        }
        handleVerificarRepresentantes();
    }, [asociacion, cooperativasList]);
    
    const handleVerificarRepresentantes = () => {
        const filtered = representantes.filter(item => {
            const cumpleEstatus = estatusFiltro === '' || item.estatus === estatusFiltro;
            const cumpleNombre = !busquedaNombre || 
                (item.nombre_representante && item.nombre_representante.toLowerCase().includes(busquedaNombre.toLowerCase()));
            const cumpleDNI = !busquedaDNI || 
                (item.dni && item.dni.includes(busquedaDNI));
            const cumpleDepartamento = !departamento || String(item.cod_depto) === String(departamento);
            const cumpleMunicipio = !municipio || String(item.cod_municipio) === String(municipio);
            const cumpleAsociacion = !asociacion || String(item.cod_asociacion) === String(asociacion);
            const cumpleCooperativa = !cooperativa || String(item.cod_cooperativa) === String(cooperativa);
            const fechaVencimiento = new Date(item.fecha_vencimiento);
            const cumpleFechaDesde = !fechaDesde || fechaVencimiento >= new Date(fechaDesde);
            const cumpleFechaHasta = !fechaHasta || fechaVencimiento <= new Date(fechaHasta);
            return cumpleEstatus && cumpleDepartamento && cumpleMunicipio && cumpleAsociacion && 
                   cumpleCooperativa && cumpleNombre && cumpleDNI && cumpleFechaDesde && cumpleFechaHasta;
        });
        setRepresentantesFiltrados(filtered);
        const vigentes = filtered.filter(rep => rep.estatus === 'VIGENTE').length;
        const vencidos = filtered.filter(rep => rep.estatus === 'VENCIDA').length;

        if (filtered.length === 0) {
            setAlertMessage('No se encontraron representantes con los criterios seleccionados.');
            setAlertType('info');
            setOpenAlert(true);
        } else {
            let mensaje = `Se encontraron ${filtered.length} representantes.`;
            if (vigentes > 0 && vencidos > 0) {
                mensaje += ` (${vigentes} vigentes, ${vencidos} vencidos)`;
            } else if (vigentes > 0) {
                mensaje += ` (${vigentes} vigentes)`;
            } else if (vencidos > 0) {
                mensaje += ` (${vencidos} vencidos)`;
            }
            setAlertMessage(mensaje);
            setAlertType('success');
            setOpenAlert(true);
        }
        setPage(0);
    };

    const handleBusquedaNombreChange = (e) => {
        setBusquedaNombre(e.target.value);
        setTimeout(handleVerificarRepresentantes, 300);
    };

    const handleDepartamentoChange = (e) => {
        setDepartamento(e.target.value);
    };

    const handleMunicipioChange = (e) => {
        setMunicipio(e.target.value);
        setTimeout(handleVerificarRepresentantes, 0);
    };

    const handleAsociacionChange = (e) => {
        setAsociacion(e.target.value);
    };

    const handleCooperativaChange = (e) => {
        setCooperativa(e.target.value);
        setTimeout(handleVerificarRepresentantes, 0);
    };

    const handleEstatusChange = (e) => {
        setEstatusFiltro(e.target.value);
        setTimeout(() => {
            const filtroTemporal = e.target.value;
            const filtered = representantes.filter(item => {
                const cumpleEstatus = filtroTemporal === '' || item.estatus === filtroTemporal;
                const cumpleNombre = !busquedaNombre || 
                    (item.nombre_representante && item.nombre_representante.toLowerCase().includes(busquedaNombre.toLowerCase()));
                const cumpleDNI = !busquedaDNI || 
                    (item.dni && item.dni.includes(busquedaDNI));
                const cumpleDepartamento = !departamento || String(item.cod_depto) === String(departamento);
                const cumpleMunicipio = !municipio || String(item.cod_municipio) === String(municipio);
                const cumpleAsociacion = !asociacion || String(item.cod_asociacion) === String(asociacion);
                const cumpleCooperativa = !cooperativa || String(item.cod_cooperativa) === String(cooperativa);
                const fechaVencimiento = new Date(item.fecha_vencimiento);
                const cumpleFechaDesde = !fechaDesde || fechaVencimiento >= new Date(fechaDesde);
                const cumpleFechaHasta = !fechaHasta || fechaVencimiento <= new Date(fechaHasta);
                return cumpleEstatus && cumpleDepartamento && cumpleMunicipio && cumpleAsociacion && 
                       cumpleCooperativa && cumpleNombre && cumpleDNI && cumpleFechaDesde && cumpleFechaHasta;
            });
            setRepresentantesFiltrados(filtered);
            setPage(0);
        }, 0);
    };

    const handleFechaDesdeChange = (e) => {
        setFechaDesde(e.target.value);
        setTimeout(handleVerificarRepresentantes, 0);
    };

    const handleFechaHastaChange = (e) => {
        setFechaHasta(e.target.value);
        setTimeout(handleVerificarRepresentantes, 0);
    };

    const handleLimpiarFiltros = () => {
        setDepartamento('');
        setMunicipio('');
        setAsociacion('');
        setCooperativa('');
        setEstatusFiltro('');
        setBusquedaNombre('');
        setBusquedaDNI('');
        setFechaDesde('');
        setFechaHasta('');
        setRepresentantesFiltrados([]);
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    };

    return (
        <Container 
            maxWidth="lg" 
            sx={{ 
                p: { xs: 1, sm: 2, md: 3 },
                backgroundColor: '#f9f7f4',
                minHeight: '100vh'
            }}
        >
            {/* Header mejorado */}
            <Fade in={true} timeout={800}>
                <Paper 
                    elevation={4}
                    sx={{ 
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: 'center',
                        mb: { xs: 2, sm: 3 },
                        p: 3,
                        backgroundColor: '#ffffff',
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(67, 41, 24, 0.1)',
                        border: '1px solid rgba(193, 168, 140, 0.2)'
                    }}
                >
                    <Box 
                        component="img"
                        src={logo}
                        alt="Logo FCN"
                        sx={{ 
                            maxWidth: isMobile ? '80px' : '120px', 
                            marginRight: { xs: 0, sm: '20px' },
                            marginBottom: { xs: '15px', sm: 0 },
                            filter: 'drop-shadow(0 4px 8px rgba(67, 41, 24, 0.1))',
                            alignSelf: { xs: 'center', sm: 'flex-start' }
                        }} 
                    />
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', ml: { xs: 0, sm: '-140px' } }}>
    <Typography variant="h8" sx={{ color: '#5f3c26ff', fontWeight: 700, fontSize: { xs: '1.2rem', sm: '1.8rem' }, mb: 0.5, lineHeight: 1.2, fontFamily: "'Roboto', sans-serif", letterSpacing: '0.02em' }}>
        VERIFICACION DE REPRESENTANTES 
    </Typography>
</Box>
                </Paper>
            </Fade>
            
            {/* Filtros mejorados */}
            <Grow in={true} timeout={1000}>
                <Paper 
                    elevation={3} 
                    sx={{ 
                        mb: 3, 
                        backgroundColor: '#fcfcfcc2',
                        borderRadius: 3,
                        overflow: 'hidden',
                        border: '1px solid rgba(193, 168, 140, 0.3)'
                    }}
                >
                    <Box 
                        sx={{ 
                            p: 3, 
                            pb: filtersExpanded ? 2 : 3,
                            background: 'linear-gradient(to right, #fcfcfcc2, #f9f7f4)',
                            borderBottom: filtersExpanded ? '1px solid rgba(193, 168, 140, 0.2)' : 'none'
                        }}
                    >
                        <Box 
                            sx={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                            onClick={() => setFiltersExpanded(!filtersExpanded)}
                        >
                            <Typography 
                                variant="h6" 
                                sx={{ 
                                    color: '#8b3e0aff', 
                                    fontSize: { xs: '1.1rem', sm: '1.25rem' },
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1
                                }}
                            >
                                FILTROS DE BÚSQUEDA
                            </Typography>
                            <IconButton 
                                size="small" 
                                sx={{ 
                                    color: '#8b3e0aff',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                {filtersExpanded ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </Box>
                    </Box>
                    
                    <Collapse in={filtersExpanded}>
                        <Box sx={{ p: 3, pt: 2 }}>
                            <form onSubmit={(e) => e.preventDefault()}>
                                <Grid container spacing={{ xs: 2, sm: 3 }}>
                                    {/* Filtro de Estado */}
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <FormControl 
                                            variant="outlined" 
                                            fullWidth 
                                            size="small"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    },
                                                    '&.Mui-focused': {
                                                        boxShadow: '0 4px 12px rgba(193, 168, 140, 0.2)'
                                                    }
                                                }
                                            }}
                                        >
                                            <InputLabel>Estatus</InputLabel>
                                            <Select
                                                value={estatusFiltro}
                                                onChange={handleEstatusChange}
                                                label="Estatus"
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                <MenuItem value="VIGENTE">VIGENTE</MenuItem>
                                                <MenuItem value="VENCIDA">VENCIDA</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* Resto de filtros con el mismo styling mejorado */}
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <FormControl 
                                            variant="outlined" 
                                            fullWidth 
                                            size="small"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    }
                                                }
                                            }}
                                        >
                                            <InputLabel>Departamento</InputLabel>
                                            <Select
                                                value={departamento}
                                                onChange={handleDepartamentoChange}
                                                label="Departamento"
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                {departamentos.map(dept => (
                                                    <MenuItem key={dept.CodigoDepartamento} value={dept.CodigoDepartamento}>
                                                        {dept.NombreDepartamento}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <FormControl 
                                            variant="outlined" 
                                            fullWidth 
                                            size="small"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    }
                                                }
                                            }}
                                        >
                                            <InputLabel>Municipio</InputLabel>
                                            <Select
                                                value={municipio}
                                                onChange={handleMunicipioChange}
                                                label="Municipio"
                                                disabled={!departamento}
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                {municipiosFiltrados.map(mun => (
                                                    <MenuItem key={mun.CodigoMunicipio} value={mun.CodigoMunicipio}>
                                                        {mun.NombreMunicipio}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <FormControl 
                                            variant="outlined" 
                                            fullWidth 
                                            size="small"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    }
                                                }
                                            }}
                                        >
                                            <InputLabel>Asociación</InputLabel>
                                            <Select
                                                value={asociacion}
                                                onChange={handleAsociacionChange}
                                                label="Asociación"
                                            >
                                                <MenuItem value=""><em>Todas</em></MenuItem>
                                                {Object.entries(asociaciones).map(([key, value]) => (
                                                    <MenuItem key={key} value={key}>
                                                        {value}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <FormControl 
                                            variant="outlined" 
                                            fullWidth 
                                            size="small"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    }
                                                }
                                            }}
                                        >
                                            <InputLabel>Cooperativa</InputLabel>
                                            <Select
                                                value={cooperativa}
                                                onChange={handleCooperativaChange}
                                                label="Cooperativa"
                                                disabled={!asociacion}
                                            >
                                                <MenuItem value=""><em>Todas</em></MenuItem>
                                                {cooperativasFiltradas.map(coop => (
                                                    <MenuItem key={coop.cod_cooperativa} value={coop.cod_cooperativa}>
                                                        {coop.nombre_cooperativa}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <TextField
                                            label="Buscar por Nombre"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={busquedaNombre}
                                            onChange={handleBusquedaNombreChange}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    },
                                                    '&.Mui-focused': {
                                                        boxShadow: '0 4px 12px rgba(193, 168, 140, 0.2)'
                                                    }
                                                }
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <Search style={{ color: '#432918' }} />
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <TextField
                                            label="DNI"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={busquedaDNI}
                                            onChange={handleBusquedaDNIChange}
                                            placeholder="0000-0000-00000"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    },
                                                    '&.Mui-focused': {
                                                        boxShadow: '0 4px 12px rgba(193, 168, 140, 0.2)'
                                                    }
                                                }
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <Search style={{ color: '#b14b08ff' }} />
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <TextField
                                            label="Vencimiento Desde"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            value={fechaDesde}
                                            onChange={handleFechaDesdeChange}
                                            InputLabelProps={{ shrink: true }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    }
                                                }
                                            }}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <TextField
                                            label="Vencimiento Hasta"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            value={fechaHasta}
                                            onChange={handleFechaHastaChange}
                                            InputLabelProps={{ shrink: true }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 2px 8px rgba(67, 41, 24, 0.1)'
                                                    }
                                                }
                                            }}
                                        />
                                    </Grid>

<Grid item xs={12}>
    <Box sx={{ display: 'flex', gap: 1.5, justifyContent: { xs: 'center', sm: 'flex-end' }, flexDirection: { xs: 'column', sm: 'row' }, mt: 2 }}>
        <Button variant="contained" onClick={handleVerificarRepresentantes} startIcon={<Search sx={{ color: '#634c31ff' }} />} sx={{ backgroundColor: '#ac9480ff', color: '#ffffff', minWidth: { xs: '100%', sm: '120px' }, py: 0.75, px: 2, borderRadius: 1.5, fontSize: '0.85rem', fontWeight: '500', textTransform: 'none', '&:hover': { backgroundColor: '#b8987c', transform: 'translateY(-1px)', transition: 'all 0.2s ease' }, '&:active': { transform: 'translateY(0px)', transition: 'all 0.1s ease' } }}>
            Buscar
        </Button>
        <Button variant="contained" onClick={handleLimpiarFiltros} startIcon={<RestartAlt sx={{ color: '#634c31ff' }} />} sx={{ backgroundColor: '#ac9480ff', color: '#ffffff', minWidth: { xs: '100%', sm: '120px' }, py: 0.75, px: 2, borderRadius: 1.5, fontSize: '0.85rem', fontWeight: '500', textTransform: 'none', '&:hover': { backgroundColor: '#b8987c', transform: 'translateY(-1px)', transition: 'all 0.2s ease' }, '&:active': { transform: 'translateY(0px)', transition: 'all 0.1s ease' } }}>
            Limpiar
        </Button>
    </Box>
</Grid>


                                </Grid>
                            </form>
                        </Box>
                    </Collapse>
                </Paper>
            </Grow>

            {/* Resultados mejorados */}
            <Fade in={true} timeout={1200}>
                <Paper 
                    elevation={3} 
                    sx={{ 
                        borderRadius: 3,
                        overflow: 'hidden',
                        border: '1px solid rgba(193, 168, 140, 0.2)'
                    }}
                >
                    {/* Vista Desktop - Tabla mejorada */}
                    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                        {loading ? (
                            <Box sx={{ p: 3 }}>
                                <SkeletonTable />
                            </Box>
                        ) : (
                            <TableContainer style={{ overflowX: 'auto' }}>
                                <Table style={{ backgroundColor: '#FFFFFF' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell 
                                                style={{ 
                                                    backgroundColor: '#f3f0ebde',
                                                    color: '#432918', 
                                                    fontWeight: 'bold', 
                                                    textAlign: 'center', 
                                                    width: '60px',
                                                    borderBottom: '2px solid #f1a307ff'
                                                }}
                                            >
                                                Estado
                                            </TableCell>
                                            <TableCell 
                                                style={{ 
                                                    backgroundColor: '#f3f0ebde', 
                                                    color: '#432918', 
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    borderBottom: '2px solid #f1a307ff'
                                                }}
                                            >
                                                Asociación
                                            </TableCell>
                                            <TableCell 
                                                style={{ 
                                                    backgroundColor: '#f3f0ebde', 
                                                    color: '#432918', 
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    borderBottom: '2px solid #f1a307ff'
                                                }}
                                            >
                                                Representante
                                            </TableCell>
                                            <TableCell 
                                                style={{ 
                                                    backgroundColor: '#f3f0ebde', 
                                                    color: '#432918', 
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    borderBottom: '2px solid #f1a307ff'
                                                }}
                                            >
                                                DNI
                                            </TableCell>
                                            <TableCell 
                                                style={{ 
                                                    backgroundColor: '#f3f0ebde', 
                                                    color: '#432918', 
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    borderBottom: '2px solid #f1a307ff'
                                                }}
                                            >
                                                Teléfono
                                            </TableCell>
                                            <TableCell 
                                                style={{ 
                                                    backgroundColor: '#f3f0ebde', 
                                                    color: '#432918', 
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    borderBottom: '2px solid #f1a307ff'
                                                }}
                                            >
                                                Municipio
                                            </TableCell>
                                            <TableCell 
                                                style={{ 
                                                    backgroundColor: '#f3f0ebde', 
                                                    color: '#432918', 
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    borderBottom: '2px solid #f1a307ff'
                                                }}
                                            >
                                                Vencimiento
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {representantesFiltrados.length > 0 ? (
                                            representantesFiltrados
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((item, index) => (
                                                    <TableRow 
                                                        key={index} 
                                                        style={{
                                                            ...getRowStyle(item.estatus, index),
                                                            '&:hover': {
                                                                backgroundColor: item.estatus === 'VENCIDA' ? '#fff5e6' : '#f5f5f5',
                                                                cursor: 'pointer'
                                                            }
                                                        }}
                                                        hover
                                                    >
                                                        <TableCell style={{ color: '#332821ff', textAlign: 'center', padding: '16px' }}>
                                                            {renderEstatusIcon(item.estatus, item)}
                                                        </TableCell>
                                                        <TableCell style={{ color: '#432918', fontWeight: '500', textAlign: 'center' }}>
                                                            {asociaciones[item.cod_asociacion] || 'N/A'}
                                                        </TableCell>
                                                        <TableCell style={{ color: '#432918', fontWeight: '500', textAlign: 'center' }}>
                                                            {item.nombre_representante || 'N/A'}
                                                        </TableCell>
                                                        <TableCell style={{ color: '#432918', textAlign: 'center' }}>
                                                            {item.dni || 'N/A'}
                                                        </TableCell>
                                                        <TableCell style={{ color: '#432918', textAlign: 'center' }}>
                                                            {item.telefono || 'N/A'}
                                                        </TableCell>
                                                        <TableCell style={{ color: '#432918', textAlign: 'center' }}>
                                                            {municipios.find(m => m.CodigoMunicipio === item.cod_municipio)?.NombreMunicipio || 'N/A'}
                                                        </TableCell>
                                                        <TableCell style={{ color: '#432918', textAlign: 'center' }}>
                                                            {item.fecha_vencimiento ? formatDate(item.fecha_vencimiento) : 'N/A'}
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={7} style={{ padding: '40px', textAlign: 'center', color: '#432918' }}>
                                                    <Box>
                                                       
                                                        <Typography variant="body2" sx={{ color: '#432918' }}>
                                                            Utilice los filtros para buscar representantes
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>

                    {/* Vista Móvil - Cards mejoradas */}
                    <Box sx={{ display: { xs: 'block', md: 'none' }, p: { xs: 2, sm: 3 } }}>
                        <Typography 
                            variant="subtitle1" 
                            sx={{ 
                                mb: 2, 
                                color: '#432918', 
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                        >
                            {representantesFiltrados.length > 0 
                                ? `Encontrados: ${representantesFiltrados.length}` 
                                : 'Resultados'}
                        </Typography>
                        
                        {loading ? (
                            <SkeletonCards />
                        ) : representantesFiltrados.length > 0 ? (
                            representantesFiltrados
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((item, index) => (
                                    <Grow key={index} in={true} timeout={300 + (index * 100)}>
                                        <Paper 
                                            elevation={2} 
                                            sx={{ 
                                                mb: 2, 
                                                p: 2, 
                                                borderRadius: 2,
                                                ...getRowStyle(item.estatus, index),
                                                '&:hover': {
                                                    transform: 'translateY(-2px)',
                                                    boxShadow: '0 8px 16px rgba(67, 41, 24, 0.1)',
                                                    transition: 'all 0.3s ease'
                                                }
                                            }}
                                        >
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sx={{ mb: 1 }}>
                                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                                        <Typography 
                                                            variant="subtitle1" 
                                                            sx={{ 
                                                                fontWeight: 'bold',
                                                                color: '#432918'
                                                            }}
                                                        >
                                                            {item.nombre_representante || 'N/A'}
                                                        </Typography>
                                                        {renderEstatusIndicator(item.estatus)}
                                                    </Box>
                                                </Grid>
                                                
                                                <Grid item xs={5}>
                                                    <Typography variant="caption" sx={{ color: '#8b3e0aff', fontWeight: '600' }}>
                                                        Asociación:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography variant="body2" sx={{ color: '#432918' }}>
                                                        {asociaciones[item.cod_asociacion] || 'N/A'}
                                                    </Typography>
                                                </Grid>
                                                
                                                <Grid item xs={5}>
                                                    <Typography variant="caption" sx={{ color: '#8b3e0aff', fontWeight: '600' }}>
                                                        DNI:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography variant="body2" sx={{ color: '#432918' }}>
                                                        {item.dni || 'N/A'}
                                                    </Typography>
                                                </Grid>
                                                
                                                <Grid item xs={5}>
                                                    <Typography variant="caption" sx={{ color: '#8b3e0aff', fontWeight: '600' }}>
                                                        Teléfono:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography variant="body2" sx={{ color: '#432918' }}>
                                                        {item.telefono || 'N/A'}
                                                    </Typography>
                                                </Grid>
                                                
                                                <Grid item xs={5}>
                                                    <Typography variant="caption" sx={{ color: '#8b3e0aff', fontWeight: '600' }}>
                                                        Municipio:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography variant="body2" sx={{ color: '#432918' }}>
                                                        {municipios.find(m => m.CodigoMunicipio === item.cod_municipio)?.NombreMunicipio || 'N/A'}
                                                    </Typography>
                                                </Grid>
                                                
                                                <Grid item xs={5}>
                                                    <Typography variant="caption" sx={{ color: '#8b3e0aff', fontWeight: '600' }}>
                                                        Vencimiento:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography variant="body2" sx={{ color: '#432918' }}>
                                                        {item.fecha_vencimiento ? formatDate(item.fecha_vencimiento) : 'N/A'}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grow>
                                ))
                        ) : (
                            <Box textAlign="center" p={4}>
                                <Typography variant="h6" sx={{ mb: 1, color: '#8b3e0aff' }}>
                                    No hay representantes disponibles
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#432918' }}>
                                    Utilice los filtros para buscar representantes
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    
                    {/* Paginación mejorada */}
                    <Box sx={{ borderTop: '1px solid rgba(193, 168, 140, 0.2)', backgroundColor: '#fcfcfcc2' }}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={representantesFiltrados.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Filas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            sx={{ 
                                color: '#432918',
                                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                },
                                '& .MuiTablePagination-actions button': {
                                    color: '#432918',
                                    '&:hover': {
                                        backgroundColor: 'rgba(67, 41, 24, 0.05)'
                                    }
                                }
                            }}
                        />
                    </Box>
                </Paper>
            </Fade>

            {/* Snackbar mejorado */}
            <Snackbar 
                open={openAlert} 
                autoHideDuration={6000} 
                onClose={handleCloseAlert}
                anchorOrigin={{ 
                    vertical: isMobile ? 'top' : 'bottom', 
                    horizontal: 'center' 
                }}
            >
                <Alert 
                    onClose={handleCloseAlert} 
                    severity={alertType} 
                    sx={{ 
                        width: '100%',
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        borderRadius: 2,
                        boxShadow: '0 8px 32px rgba(67, 41, 24, 0.15)'
                    }}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default Verificar;